'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component to use Google Tag Manager on the page. This component should
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * only be mounted when the GMT ID has be defined.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module GoogleTagManager
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 2.1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * Set up the GTM tracking. Apart from a `noscript` fallback, this pretty
 * much doesn't render anything, but sets up the GTM dataLayer in the
 * constructor, loads the GTM.js script by Google while mounting and pushes
 * a pageview event into the dataLayer, using the passed-in props.
 *
 * Apart from props.gtmId, all props are part of the statistics object
 * provided by the Newsnet API.
 *
 * As this class extends `PureComponent`, it shouldn't be rerendered all the
 * time.
 *
 * @param {string} props.gtmId The GTM ID to use.
 * @param {string} props.pagetype The pagetype (e.g. 'article').
 * @param {string} props.category The category of the article.
 * @param {string=} props.subcategory The subcategory of the article.
 * @param {number=} props.article_id The legacy article ID.
 * @param {bool=} props.premium Whether this is a premium article.
 * @extends React.PureComponent
 */
var GoogleTagManager = function (_React$PureComponent) {
  _inherits(GoogleTagManager, _React$PureComponent);

  function GoogleTagManager(props) {
    _classCallCheck(this, GoogleTagManager);

    // Setup the data layer used by the tag manager.
    var _this = _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).call(this, props));

    window.dataLayer = window.dataLayer || [];
    return _this;
  }

  /**
   * Renders the noscript fallback.
   *
   * Does rendering something using a noscript tag make much sense? Not at
   * first, but according to
   * https://twitter.com/bockph/status/793399813089923072 it can be useful
   * in isomorphic environments (where parts of the code is rendered on the
   * server).
   *
   * @private
   * @returns {null | XML}
   */


  _createClass(GoogleTagManager, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'noscript',
        null,
        _react2.default.createElement('iframe', {
          src: '//www.googletagmanager.com/ns.html?id=' + this.props.gtmId,
          height: '0', width: '0',
          style: {
            display: 'none',
            visibility: 'hidden',
            position: 'absolute'
          } })
      );
    }

    /**
     * Once the component mounts, the setup script by google is called. This
     * will download the additional gtm.js script from Google's server. This
     * should only happen once.
     *
     * @private
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      //region Code Snippet from Google
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', this.props.gtmId);
      //endregion

      // Push page view event to the data layer
      // Why is this happening here?
      // 1. We know the dataLayer exists (it has been set up in the constructor)
      // 2. componentDidMount will only be called once, as opposed to other
      // lifecycle events, so the pageview event should only be triggered once.
      window.dataLayer.push({
        'event': 'pageview',
        'pagetype': this.props.pagetype,
        'category': this.props.category,
        'subcategory': this.props.subcategory || '',
        'article_id': this.props.article_id || '',
        'premium': this.props.premium ? 1 : 0
      });
    }
  }]);

  return GoogleTagManager;
}(_react2.default.PureComponent);

exports.default = GoogleTagManager;


GoogleTagManager.propTypes = {
  gtmId: _react2.default.PropTypes.string.isRequired,
  pagetype: _react2.default.PropTypes.string.isRequired,
  category: _react2.default.PropTypes.string.isRequired,
  subcategory: _react2.default.PropTypes.string,
  article_id: _react2.default.PropTypes.number,
  premium: _react2.default.PropTypes.bool
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/ta-react-gtm/dist/index.js
 ** module id = 1816
 ** module chunks = 0
 **/